__webpack_require__.p = "/megaminx-12-sided-rubiks-cube-web-app/";